export default __webpack_public_path__ + "static/media/640_dummy2016-restaurant03-mobile-de.47c56a53.png";